import { useEffect, useState } from 'react';
import SelectDropdown from '../../SelectDropdown/SelectDropdown';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import { CustomToolbarBtnProps } from '../types/customToolbarBtnTypes';

// Available text level options
const options = [
  <FormatAlignLeftIcon />,
  <FormatAlignCenterIcon />,
  <FormatAlignRightIcon />,
];

const optionAssocs = ['left', 'center', 'right'];

export default function TextAlignSelect({ editor, disabled }: CustomToolbarBtnProps) {
  const [selectedIndex, setSelectedAlign] = useState(0);

  useEffect(() => {
    // Update selected index when editor text has active alignement setting
    const updateTextAlign = () => {
      if (editor?.isActive('heading') || editor?.isActive('paragraph')) {
        let textAlign =
          editor?.getAttributes('heading').textAlign ||
          editor?.getAttributes('paragraph').textAlign;

        if (!optionAssocs.includes(textAlign)) {
          textAlign = 'left';
        }

        const textAlignIndex = optionAssocs.indexOf(textAlign);

        setSelectedAlign(textAlignIndex);
      } else {
        setSelectedAlign(0);
      }
    };

    editor?.on('selectionUpdate', updateTextAlign);

    return () => {
      editor?.off('selectionUpdate', updateTextAlign);
    };
  }, [editor]);

  // Handle option selection
  const handleOptionSelect = (index: number) => {
    if (index === 0) {
      editor?.commands.toggleTextAlign('left');
    } else if (index <= 6) {
      editor?.commands.toggleTextAlign(optionAssocs[index]);
    }
    editor?.commands.focus();
  };

  return (
    <SelectDropdown
      options={options}
      onOptionSelect={handleOptionSelect}
      controlledSelectedIndex={selectedIndex}
      disabled={disabled}
    />
  );
}
